import { render, staticRenderFns } from "./comp_CartAutoRemovalsModal.vue?vue&type=template&id=1fd99c04&scoped=true"
import script from "./comp_CartAutoRemovalsModal.vue?vue&type=script&lang=js"
export * from "./comp_CartAutoRemovalsModal.vue?vue&type=script&lang=js"
import style0 from "./comp_CartAutoRemovalsModal.vue?vue&type=style&index=0&id=1fd99c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd99c04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VDialog,VDivider,VIcon,VListItem,VSpacer})
